import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';
import { LazyLoadEvent } from '../models/DataTables/lazyLoadEvent';
import { CreateInstitutionModel, EditInstitutionModel, Institution } from '../models/inModels/Institution';

@Injectable()
export class InstitutionService {
  private routeInstitutions = 'api/institutions';
  constructor(
    private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
  ) { }

  search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/institutions/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
  }
  	
  get(id: number): Promise<Institution> {
    return this.http.get(`${this.auth.apiUrl}/api/institutions/get/${id}`, { headers: this.auth.header })
      .toPromise()
      .then(response => response as Institution)
      .catch(error => this.logging.handleError(error));
  }

  
  create(user: CreateInstitutionModel): Promise<Institution> {
    debugger;
		return this.http.post(`${this.auth.apiUrl}/api/institutions/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Institution)
			.catch(error => this.logging.handleError(error));
  }
  
  update(user: EditInstitutionModel): Promise<Institution> {
		return this.http.post(`${this.auth.apiUrl}/api/institutions/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Institution)
			.catch(error => this.logging.handleError(error));
  }

  delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/institutions/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
  
}



// WEBPACK FOOTER //
// ./src/app/services/institution.service.ts